import { useServerDataContext } from "~/providers/ServerDataProvider";

type RootData = ReturnType<typeof useServerDataContext>["rootData"];
type SiteData = ReturnType<typeof useServerDataContext>["siteData"];

/**
 * Return data from a specific loader.
 * @see https://remix.run/docs/en/main/hooks/use-route-loader-data
 */
export function useRouteLoaderData(route: "root"): RootData;
export function useRouteLoaderData(route: "routes/$site"): SiteData;
export function useRouteLoaderData(
  route: "root" | "routes/$site",
): RootData | SiteData {
  const { rootData, siteData } = useServerDataContext();

  if ("root" === route) return rootData;

  if ("routes/$site" === route) return siteData;

  throw new Error(`Loader route ${route} not recognized.`);
}
